<template>
  <div class="callout-product-card critical-component-clear">
    <div class="callout-product-card__inner container">
      <div class="callout-product-card__image-wrapper">
        <responsive-image
          class="callout-product-card__image"
          :image="image"
          ratio="1:1"
          sizes="(min-width: 1024px) 620px, 375px"
        />
      </div>

      <div class="callout-product-card__content text-center">
        <p
          v-if="liquid.subtitle"
          class="callout-product-card__subtitle text-mobile-paragraph-s-regular text-desktop-paragraph-s-regular"
          v-text="liquid.subtitle"
        />

        <p
          v-if="title"
          class="callout-product-card__title text-mobile-headlines-h2 text-desktop-headlines-h2"
          v-text="title"
        />

        <div v-if="liquid.text" class="callout-product-card__text">
          <rte-content :content="liquid.text" />
        </div>

        <btn
          v-if="product"
          modifiers="secondary block center"
          :url="product.selectedOrFirstAvailableVariant.url"
          :label="liquid.ctaText"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { formatProduct } from '~/format/format-product';
import { transformId } from '~/helpers/graphql';

import Btn from '~global/btn/btn.vue';
import ResponsiveImage from '~global/images/responsive-image.vue';
import RteContent from '~async/rte-content/rte-content.vue';

import nodesByIdQuery from '~graphql/nodes-by-id-product-card.gql';

/**
 * Vue: Callout product card (callout-product-card)
 * -----------------------------------------------------------------------------
 * Callout product card.
 *
 */
export default {
  name: 'CalloutProductCard',

  components: {
    Btn,
    ResponsiveImage,
    RteContent,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        title: '',
        text: '',
        image: '',
        ctaText: '',
        productId: '',
        variantId: '',
      }),
    },
  },

  data() {
    return {
      product: null,
    };
  },

  computed: {
    title() {
      return this.liquid.title || this.product?.title;
    },

    image() {
      return (
        this.liquid.image ||
        this.product?.selectedOrFirstAvailableVariant?.variantFeaturedImage
          ?.reference ||
        this.product?.selectedOrFirstAvailableVariant?.featuredImage
      );
    },
  },

  mounted() {
    this.fetchProduct();
  },

  methods: {
    async fetchProduct() {
      try {
        const response = await cnvs.Query({
          query: nodesByIdQuery,
          variables: {
            country: this.$variable('store.country'),
            language: this.$variable('store.language'),
            ids: transformId(this.liquid.productId, 'Product'),
          },
        });

        this.product = formatProduct(response.nodes[0], {
          variantId: Number(this.liquid.variantId),
        });

        await this.$nextTick();
      } catch (error) {
        cnvs.ReportError('Failed to load product', error);
      }
    },
  },
};
</script>

<style lang="scss">
@import './callout-product-card';
</style>
